module.exports = __webpack_public_path__ + "img/ICONO20.c1ca0831.png";